module.exports = __webpack_public_path__ + "static/media/medias_sociaux_LTM.891113da.doc";